import { REWARDS_DISCOUNT_TYPES } from "@apps/rewards/constants/rewardsDiscountTypes";
import { enums, literal, nullable, number, object, string } from "superstruct";

export const DiscountRewardSchema = object({
    type: literal("discount"),
    discountType: enums(Object.values(REWARDS_DISCOUNT_TYPES)),
    discountValue: nullable(number()),
    expirationInDays: nullable(number()),
    minimumOrderAmount: nullable(number()),
    discountCode: string(),
});
